import Languages from '@/assets/enums/config/Languages'

const SUPPORT_TIME_ZONE = 'Europe/Brussels'
const SUPPORT_BASE_URL = 'https://erp-support.enaos.com'

// Monday to Friday, in minutes since midnight (Brussels time). The lunch
// break shown in the opening hours is left out: the team stays reachable.
const OPENING_FROM = 9 * 60
const OPENING_TO = 17 * 60
const WORKING_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']

const supportClock = new Intl.DateTimeFormat('en-US', {
  timeZone: SUPPORT_TIME_ZONE,
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23'
})

export interface SupportPhone {
  label: string
  href: string
}

export interface HelpCenterLinks {
  submitRequest: string
  myRequests: string
  knowledgeBase: string
}

/**
 * Whether the support team is reachable at `date`, on its Brussels opening
 * hours. Public holidays are not taken into account.
 */
export function isSupportOpen(date: Date = new Date()): boolean {
  const parts = Object.fromEntries(
    supportClock.formatToParts(date).map((part) => [part.type, part.value])
  )
  if (!WORKING_DAYS.includes(parts.weekday)) return false
  const minutes = Number(parts.hour) * 60 + Number(parts.minute)
  return minutes >= OPENING_FROM && minutes < OPENING_TO
}

function isDutch(locale: string): boolean {
  return locale?.startsWith('nl')
}

export function helpCenterLinks(locale: string): HelpCenterLinks {
  const root = `${SUPPORT_BASE_URL}/${isDutch(locale) ? 'nl' : 'fr'}`
  return {
    submitRequest: `${root}/contact-us`,
    myRequests: `${root}/customer-portal`,
    knowledgeBase: root
  }
}

export function supportPhone(locale: string): SupportPhone {
  if (isDutch(locale)) {
    return { label: '02 213 37 29', href: 'tel:+3222133729' }
  }
  if (locale === Languages.FRENCH_FRANCE) {
    return { label: '03 53 32 00 17', href: 'tel:+33353320017' }
  }
  return { label: '02 899 86 66', href: 'tel:+3228998666' }
}
